import React from 'react';
import { Link } from 'react-router-dom';
import { SocialIcon } from '../common/Icons';
import { footerLinks, socialLinks, companyInfo } from '../../data/siteData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-primary-500 to-secondary-400 flex items-center justify-center font-gaming font-bold text-xl">
                RB
              </div>
              <span className="font-gaming text-xl">
                <span className="text-primary-500">RIVEN</span>
                <span className="text-secondary-400">BYTE</span>
              </span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              {companyInfo.tagline} from the heart of Tanzania to the world.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              {Object.entries(socialLinks).slice(0, 4).map(([platform, url]) => (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-500 hover:text-white hover:bg-white/10 transition-all"
                  aria-label={platform}
                >
                  <SocialIcon platform={platform} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-primary-400">QUICK LINKS</h4>
            <ul className="space-y-2">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-500 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="font-bold mb-4 text-secondary-400">PLATFORMS</h4>
            <ul className="space-y-2">
              {footerLinks.platforms.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-500 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4 text-purple-400">CONTACT</h4>
            <ul className="space-y-3">
              <li className="text-gray-500 text-sm">
                <span className="block text-gray-400">Location</span>
                {companyInfo.location}
              </li>
              <li className="text-gray-500 text-sm">
                <span className="block text-gray-400">Email</span>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="hover:text-white transition-colors"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="text-gray-500 text-sm">
                <span className="block text-gray-400">Phone</span>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="hover:text-white transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            {footerLinks.legal.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-gray-600 hover:text-white transition-colors text-sm"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
